import React from 'react';

const EmptyType = (props) => {

    return (
        <div className="empty-space">
            <div dangerouslySetInnerHTML={{__html: '&nbsp;'}}/>
        </div>
    );
}

export default EmptyType;